import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import EngineFunctionsDefinition from '../../../definitions/engineFunctionsDefinition';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import FormulaUtilsTooling from '../../../tooling/formulaUtilsTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import { intl } from '../../../locales/localesConfig';
import toastr from 'toastr';
import $ from 'jquery';

/* Actions */
import * as tableEditorActions from '../../actions/tableEditor/index';

/*Components*/
import TableEditorPopup from '../../components/tableEditor/tableEditorPopup';

class TableEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableSelectedRow: null,
      tableSelectedCol: null,
      tableTargetActionRows: "",
      tableTargetRows: "1",
      pendingPasteInstancesData: {}
    };
  }
 
  async componentDidMount() {
    await this.props.actions.getDimensionsList();
  }
  
  componentDidUpdate(prevProps) {
    if(!InterfaceTooling.popupHasToRender(prevProps.popupState) && 
       InterfaceTooling.popupHasToRender(this.props.popupState)) {
      this.setState({
        tableSelectedRow: null,
        tableSelectedCol: null,
        tableTargetActionRows: "",
        tableTargetRows: "1"
      });
    }
    
    if(InterfaceTooling.popupHasToRender(this.props.popupState)) {
      //table paste dimension instances
      InterfaceTooling.apiCallResultFeedback(
        [prevProps.dimensionInstancesList.status],
        [this.props.dimensionInstancesList.status],
        intl.formatMessage({ id: "polynomialAdmin.tableEditor.dimensionInstancesListSuccess" }),
        intl.formatMessage({ id: "common.errors.genericError" }),
        [() => {
          if(this.props.dimensionInstancesList.data.length>0) {
            let empty_rows_with_column_paste = [];
            let newFormulaToEditObject = JavascriptUtilsTooling.deepCopy(this.props.formulaToEditObject);
            let formulaObject = newFormulaToEditObject.formulaArray;
            let rowsToAdd = this.props.dimensionInstancesList.data.length;
            this.props.dimensionInstancesList.data.forEach(dimensionInstance => {
              let row_to_add = JavascriptUtilsTooling.deepCopy(this.state.pendingPasteInstancesData.empty_row);
              row_to_add[this.state.pendingPasteInstancesData.tableSelectedCol] = dimensionInstance.value;
              empty_rows_with_column_paste.push(row_to_add);
            });
            formulaObject.instances.splice(this.state.pendingPasteInstancesData.tableSelectedRow, 1, ...empty_rows_with_column_paste); 
            this.props.actions.setFormulaToEditObject(newFormulaToEditObject);
          }
        }]  
      );
    }
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }

  handleValidateAndSet = (event) => {
    this.props.actions.formulaValidation(this.props.formulaToEditObject);
  };

  onChangeTableOptions = (event) => {
    if(event.currentTarget.dataset.objecteditor) {
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let objectValueAux = JSON.parse(event.currentTarget.dataset.value);
      let objectValue = {
        type: objectValueAux.type,
        name: objectValueAux.validated_by_dim_id ? this.props.dimensionsList.data.find(dim => dim.id==objectValueAux.validated_by_dim_id).name : objectValueAux.name,
        options: {
          hide: objectValueAux.hide,
          label: objectValueAux.label,
          format: objectValueAux.format,
          validated_by_dim_id: objectValueAux.validated_by_dim_id
        }
      };
      let isDelete = event.currentTarget.dataset.delete;
      let isEdit = event.currentTarget.dataset.edit;
      let newFormulaToEditObject = JavascriptUtilsTooling.deepCopy(this.props.formulaToEditObject);
      let objectDefinition = newFormulaToEditObject.formulaArray.columns;
      
      if(isDelete) { 
        let indexTransformation = {};
        let indexTransformationCount = 0;
        objectDefinition.forEach((item, item_index) => {
          if(item_index!=index) {
            indexTransformation["_" + item_index] = "_" + indexTransformationCount;
            indexTransformationCount++;
          }
        });
        indexTransformation["_" + objectDefinition.length] = "_" + indexTransformationCount
        delete objectDefinition[index];
        newFormulaToEditObject.formulaArray.columns = objectDefinition.filter(item => item);
        objectDefinition = newFormulaToEditObject.formulaArray.columns;
        newFormulaToEditObject.formulaArray.instances = newFormulaToEditObject.formulaArray.instances.map(instance => {
          let newInstanceHash = {};
          Object.entries(indexTransformation).forEach(([key, object_value]) => {
            newInstanceHash[object_value] = instance[key];
            if(instance[key + "_rest"]) { newInstanceHash[object_value + "_rest"] = true }
          });
          return newInstanceHash;
        });
      } else if(isEdit) {
        if(objectDefinition[index].type != objectValue.type) {
          newFormulaToEditObject.formulaArray.instances.forEach(instance => {
            instance["_" + index] = "";
            if(instance["_" + index + "_rest"]) { delete instance["_" + index + "_rest"]; }
          });
        }
        objectDefinition[index] = objectValue;
      } else {
        newFormulaToEditObject.formulaArray.instances.forEach(instance => {
          instance["_" + (objectDefinition.length+1)] = instance["_" + objectDefinition.length];
          instance["_" + objectDefinition.length] = "";
        });
        objectDefinition.push(objectValue);
      }
      newFormulaToEditObject.formulaArray.columns_display = objectDefinition.map((column_item,column_index) => {
        return {
          name: column_item.name,
          prop: "_" + column_index,
          type: column_item.type
        };
      });
      newFormulaToEditObject.formulaArray.columns_display.push({
        name: intl.formatMessage({id: "polynomialAdmin.tableEditor.valueColumnLabel"}),
        prop: "_" + objectDefinition.length,
        type: newFormulaToEditObject.formulaArray.type
      });
      this.props.actions.setFormulaToEditObject(newFormulaToEditObject);
    }
    else {
      let path = event.currentTarget.dataset.path;
      let value = event.currentTarget.value;
      let newFormulaToEditObject = JavascriptUtilsTooling.deepCopy(this.props.formulaToEditObject);
      if(path=="type") {
        newFormulaToEditObject.formulaArray.instances.forEach(instance => {
          instance["_" + newFormulaToEditObject.formulaArray.columns.length] = "";
        });
      }
      JavascriptUtilsTooling.setObjectStringPathKeyValue(newFormulaToEditObject.formulaArray, path, value);
      newFormulaToEditObject.formulaArray.columns_display[newFormulaToEditObject.formulaArray.columns_display.length-1].type = newFormulaToEditObject.formulaArray.type;
      this.props.actions.setFormulaToEditObject(newFormulaToEditObject);
    }
  };

  onChangeTableData = (eventData) => {
    let dataObject = eventData.detail;
    let newFormulaToEditObject = JavascriptUtilsTooling.deepCopy(this.props.formulaToEditObject);
    let instances = newFormulaToEditObject.formulaArray.instances;
    let columns_display_types_hash = {};
    let columns_display_index = {};
    let columns_value_index = newFormulaToEditObject.formulaArray.columns_display.length-1;
    newFormulaToEditObject.formulaArray.columns_display.forEach(item => {
      columns_display_types_hash[item.prop] = item.type;
    });
    newFormulaToEditObject.formulaArray.columns_display.forEach((item,item_index) => {
      columns_display_index[item.prop] = item_index;
    });
    
    if("data" in dataObject) {
      //range edit
      Object.keys(dataObject.data).forEach(dataRowKey => {
        let dataRow =  dataObject.data[dataRowKey];
        let instanceToChange = instances[dataRowKey];
        Object.keys(dataRow).forEach(instanceKey => {
          let valueToChange = dataRow[instanceKey].trim();
          let dataType = columns_display_types_hash[instanceKey];
          let dataTypeIndex = columns_display_index[instanceKey];
          if(instanceToChange[instanceKey + "_rest"]) { delete instanceToChange[instanceKey + "_rest"]; }
          
          if(valueToChange.toUpperCase() == intl.formatMessage({id: "polynomialAdmin.tableEditor.defect"}).toUpperCase() && dataType != Constants.selectKeys.formulaEditor.tableColumnTypes.RANGE && columns_value_index!=dataTypeIndex) {
            instanceToChange[instanceKey + "_rest"] = true;
            valueToChange = intl.formatMessage({id: "polynomialAdmin.tableEditor.defect"});
          }
          else if(dataType == Constants.selectKeys.formulaEditor.tableColumnTypes.NUMBER || dataType == Constants.selectKeys.formulaEditor.tableColumnTypes.RANGE) {
            valueToChange = isNaN(valueToChange) ? "" : valueToChange;
          }
          instanceToChange[instanceKey] = valueToChange;
        });
      });
    }
    else {
      //simple edit
      let valueToChange = dataObject.val.trim();
      let dataType = columns_display_types_hash[dataObject.prop];
      let dataTypeIndex = columns_display_index[dataObject.prop];
      let empty_row = {};    
      newFormulaToEditObject.formulaArray.columns_display.forEach(item => { empty_row[item.prop] = ""; });
      if(instances[dataObject.rowIndex][dataObject.prop + "_rest"]) { delete instances[dataObject.rowIndex][dataObject.prop + "_rest"] };
      
      if(valueToChange.toUpperCase() == intl.formatMessage({id: "polynomialAdmin.tableEditor.defect"}).toUpperCase() && dataType != Constants.selectKeys.formulaEditor.tableColumnTypes.RANGE && columns_value_index!=dataTypeIndex) {
        instances[dataObject.rowIndex][dataObject.prop + "_rest"] = true;
        valueToChange = intl.formatMessage({id: "polynomialAdmin.tableEditor.defect"});
      }
      else if(dataType == Constants.selectKeys.formulaEditor.tableColumnTypes.NUMBER || dataType == Constants.selectKeys.formulaEditor.tableColumnTypes.RANGE) {
        valueToChange = isNaN(valueToChange) ? "" : valueToChange;
      }
      instances[dataObject.rowIndex][dataObject.prop] = valueToChange;
      if(dataObject.rowIndex == instances.length-1) {
        instances.push(empty_row);
      }
    }
    this.props.actions.setFormulaToEditObject(newFormulaToEditObject);
    eventData.preventDefault();
  };

  handleTableSelectCell = (eventData) => { 
    let dataObject = eventData.detail;
    if(dataObject && ("rowIndex" in dataObject)) {
      //select
      this.setState({
        tableSelectedRow: dataObject.rowIndex,
        tableSelectedCol: dataObject.prop ? dataObject.prop : null
      });
    }
    else {
      //unselect
      this.setState({
        tableSelectedRow: null,
        tableSelectedCol: null
      });
    }
  };

  handleTableControlButtons = (event) => {
    let action = event.currentTarget.dataset.action;
    let newFormulaToEditObject = JavascriptUtilsTooling.deepCopy(this.props.formulaToEditObject);
    let formulaObject = newFormulaToEditObject.formulaArray;
    if(action=="target_rows") {
      this.setState({
        tableTargetRows: event.currentTarget.value
      });
    }
    else if(action=="add_rows" && this.state.tableSelectedRow!=null && (+this.state.tableTargetRows)>0) {
      let empty_row = {};
      let empty_rows = [];
      let rowsToAdd = +this.state.tableTargetRows;
      
      formulaObject.columns_display.forEach(item => { empty_row[item.prop] = ""; });
      for(let i=0; i<rowsToAdd; i++) {
        empty_rows.push(JavascriptUtilsTooling.deepCopy(empty_row));
      }
      formulaObject.instances.splice(this.state.tableSelectedRow+1, 0, ...empty_rows); 
      this.props.actions.setFormulaToEditObject(newFormulaToEditObject);
    }
    else if(action=="delete_rows" && this.state.tableSelectedRow!=null && (+this.state.tableTargetRows)>0) {
      let rowsToDelete = +this.state.tableTargetRows;
      formulaObject.instances.splice(this.state.tableSelectedRow, rowsToDelete);
      if(formulaObject.instances.length==0) {
        let empty_row = {};
        formulaObject.columns_display.forEach(item => { empty_row[item.prop] = ""; });
        formulaObject.instances.push(empty_row);
      }      
      this.props.actions.setFormulaToEditObject(newFormulaToEditObject);      
    }
    else if(action=="paste_instances" && this.state.tableSelectedRow!=null && this.state.tableSelectedCol!=null) {
      let empty_row = {};
      let columnDefinition = null;
      
      formulaObject.columns_display.forEach((item,item_index) => { 
        if(("_" + item_index)==this.state.tableSelectedCol) {
          columnDefinition = formulaObject.columns[item_index];
        }
        empty_row[item.prop] = ""; 
      });
      
      if(columnDefinition && columnDefinition.type==Constants.selectKeys.formulaEditor.tableColumnTypes.VALIDATE_BY_DIMENSION &&
        columnDefinition.options && columnDefinition.options.validated_by_dim_id) {
        this.props.actions.getDimenesionInstances({
          dimension_id: columnDefinition.options.validated_by_dim_id
        });
        this.setState({
          pendingPasteInstancesData: {
            empty_row: empty_row,
            tableSelectedRow: this.state.tableSelectedRow,
            tableSelectedCol: this.state.tableSelectedCol
          }
        });
      }
    }
    else if(action=="set_defect" && this.state.tableSelectedRow!=null && this.state.tableSelectedCol!=null) {
      if(!formulaObject.instances[this.state.tableSelectedRow][this.state.tableSelectedCol + "_rest"]) {
        formulaObject.instances[this.state.tableSelectedRow][this.state.tableSelectedCol] = intl.formatMessage({id: "polynomialAdmin.tableEditor.defect"});
        formulaObject.instances[this.state.tableSelectedRow][this.state.tableSelectedCol + "_rest"] = true;
      }
      else {
        formulaObject.instances[this.state.tableSelectedRow][this.state.tableSelectedCol] = "";
        delete formulaObject.instances[this.state.tableSelectedRow][this.state.tableSelectedCol + "_rest"];
      }
      this.props.actions.setFormulaToEditObject(newFormulaToEditObject);
    }
  };

  render() {
    const {
      handleShowTableEditorPopup,
      popupState
    } = this.props;
    return (
      <TableEditorPopup
        handleShowPopup={handleShowTableEditorPopup}
        fullLoading={this.props.formulaValidation.loading || this.props.dimensionsList.loading || this.props.dimensionInstancesList.loading}
        formulaToEditObject={this.props.formulaToEditObject}
        handleValidateAndSet={this.handleValidateAndSet}
        validationStatus={this.props.formulaValidation.status}
        dimensionsList={this.props.dimensionsList.data}
        onChangeTableOptions={this.onChangeTableOptions}
        onChangeTableData={this.onChangeTableData}                
        handleSelectCell={this.handleTableSelectCell}
        handleControlButtons={this.handleTableControlButtons}
        tableSelectedRow={this.state.tableSelectedRow}
        tableSelectedCol={this.state.tableSelectedCol}
        tableTargetRows={this.state.tableTargetRows}
        popupState={popupState}
      />
    );
  }
}

const mapStateToProps = state => ({
  dimensionsList: state.reducer.tableEditor.dimensionsList,
  dimensionInstancesList: state.reducer.tableEditor.dimensionInstancesList,
  formulaToEditObject: state.reducer.tableEditor.formulaToEditObject,
  formulaValidation: state.reducer.tableEditor.formulaValidation
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tableEditorActions, dispatch)
});

TableEditorPopup.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableEditor);



// WEBPACK FOOTER //
// ./source/client/containers/tableEditor/index.jsx